import { createAppSlice } from '../../app/createAppSlice'

const initialState = { toolName: "" };

const footerSlice = createAppSlice({
    name: "footer",
    initialState,
    reducers: create => ({
        changeTool: create.reducer((state, action) => {
            state.toolName = action.payload
        }),
    }),
    selectors: {
        selectToolName: footer => footer.toolName
    },
})

export const { changeTool } = footerSlice.actions

export const { selectToolName } = footerSlice.selectors

export default footerSlice